module.exports = __webpack_public_path__ + "img/img9.be4e6588.png";